import { createContext, useContext, useMemo, useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import api from "libs/api";

const WebmastersContext = createContext();

const WebmastersProvider = ({ children }) => {
  const { t } = useTranslation();
  const { getUserData } = useApp();

  const queryClient = useQueryClient();

  const [init_loading, setInitLoading] = useState(true);

  const { data: webmasters, isSuccess } = useQuery({
    queryKey: ["webmasters"],
    queryFn: () => api.get("/admin/webmasters?sort=first_name:asc"),
  });

  useEffect(() => {
    if (isSuccess) {
      setInitLoading(false);
    }
  }, [isSuccess]);

  const createAccount = (values) =>
    new Promise(async (resolve, reject) => {
      try {
        const webmaster = await api.post(`/admin/webmasters`, values);

        queryClient.setQueryData(["webmasters"], (prev) => [
          ...prev,
          {
            _id: webmaster?._id,
            first_name: values?.first_name,
            last_name: values?.last_name,
            email: values?.email,
          },
        ]);

        await getUserData();

        resolve();
      } catch (err) {
        console.error(err);
        toast.error(t("Something went wrong."));
        reject(err);
      }
    });

  const value = useMemo(() => {
    return {
      data: webmasters,
      init_loading,
      createAccount,
    };
    // eslint-disable-next-line
  }, [webmasters, init_loading]);

  return (
    <WebmastersContext.Provider value={value}>
      {children}
    </WebmastersContext.Provider>
  );
};

const useWebmasters = () => useContext(WebmastersContext);
export { WebmastersContext, useWebmasters };
export default WebmastersProvider;
